export interface CaWiseTransportation {
  /**
   * 目的地までの交通手段
   * 1 :飛行機 2 :バス 3 :電車 4 :新幹線 5:船
   */
  transportation_mean: 1 | 2 | 3 | 4 | 5;
  /**
   * 交通手段に飛行機を利用の場合に 便名(航空会社コードと3〜4桁の 数字で構成されるフライトナン バー)を設定します
   */
  flight_number: string;
  /**
   * 交通手段に飛行機を利用の場合に 送迎のあり・なしを設定します
   * 0 :なし 1 :あり
   */
  airport_pickup: 0 | 1;
}

export interface CaWiseDestination {
  /**
   * 目的地の名称
   */
  destination_name: string;
  /**
   * 目的地の到着日(YYYYMMDD)
   */
  arrival_date: string;
  /**
   * 宿泊施設名。目的地で宿泊がある場合に設定します
   */
  accommodation_name: string;
  /**
   * 宿泊施設の利用部屋数(数値)。 目的地で宿泊がある場合に設定します
   */
  number_of_rooms: number;
  /**
   * 目的地での食事の有無 0 :なし 1 :あり
   */
  with_meals: 0 | 1;
  transportation: CaWiseTransportation[];
}

export interface CaWiseTourReservationSummary {
  /**
   * 予約の種別
   * 1 : オンライン予約
   * 2 : オフライン予約
   * 3 : DP(ダイナミックパッケージ)商品の予約
   */
  reservation_type: 1 | 2 | 3;
  /**
   * 予約したツアーの種別
   * 1 : 国内ツアー
   * 2 : 海外ツアー
   */
  tour_type: 1 | 2;
  /**
   * 予約したツアーの合計金額(数値)
   * [国内ツアーの場合] 障害保険料を除く予約金額合計(税込)
   * [海外ツアーの場合] 障害保険料と燃油サーチャージ、保険 料、諸税を除いた旅行代金合計。旅行代 金合計に燃油サーチャージ、保険料、諸 税が含まれる場合はそれらを含めた合計 金額を設定します
   */
  amount: number;
  /**
   * 燃油サーチャージの合計金額(数値)。 旅行代金合計に燃油サーチャージを含ま ない場合に設定します
   */
  fuel_surcharge: number;
  /**
   * 燃油サーチャージを除いた諸税の合計金 額(数値)。旅行代金合計に諸税を含ま ない場合に設定します
   */
  tax: number;
  /**
   * 合計金額 に設定した金額の通貨単位(JPYなど)
   */
  currency: string;
  /**
   * 通貨単位 に設定した通貨の日本円換算 レート。 通貨単位 が JPY の場合は 1 を設定します
   */
  exchange_rate: number;
  /**
   * 料金の支払い手段。
   * 0 : クレジットカード 1 :現金
   * 2 : 電子マネー
   * 3 :その他
   */
  payment_method?: 1 | 2 | 3;
}

export interface CaWiseTourReservationDtail {
  /**
   * ツアーコード
   * 広告主が管理するプランなどの識別番号(文字列/最大32文字)
   */
  item_code: string;
  /**
   * ツアー名
   * 広告主が管理するプランなどの名称(文字列/最大128文字)
   */
  item_name: string;
  /**
   * 予約日
   * 予約したツアーの予約日 (YYYYMMDD)
   */
  reservation_date: string;
  /**
   * 出発日
   * 予約したツアーの出発日 (YYYYMMDD)
   */
  departure_date: string;
  /**
   * 出発地
   * 予約したツアーの出発地(文字列/ 最大64文字)
   */
  departure_place: string;
  /**
   * 帰着日
   * 予約したツアーの帰着日 (YYYYMMDD)
   */
  return_date: string;
  /**
   * 旅行日数
   * 予約したツアーの旅行日数(数 値)
   */
  days: number;
  /**
   * 参加者人数 予約したツアー参加者の人数(数 値)
   */
  number_of_participants: number;
  /**
   * 大人人数
   * 予約したツアー参加者の大人の人 数(数値)
   */
  number_of_adults: number;
  /**
   * 子供人数
   * 予約したツアー参加者の子供の人 数(数値)
   */
  number_of_children: number;
  /**
   * 幼児人数
   * 予約したツアー参加者の幼児の人 数(数値)
   */
  number_of_infants: number;
  destination: CaWiseDestination[];
}

export enum CAWiseUserFlag {
  NewUser = 0,
  RepeatUser,
}

export enum CAWisePayment {
  Creditcard = 0,
  /**
   * 現金
   */
  Cash,
  /**
   * 電子マネー
   */
  EMoney,
  Else,
}

export enum CAWiseMeal {
  Nothing = 0,
  Existing,
}

export interface CaWiseHotelReservation {
  productId: string;
  productName: string;
  /**
   * 予約したチェックイン日(YYYYMMDD)
   */
  checkInDate: string;
  /**
   * 予約したチェックアウト日(YYYYMMDD)
   */
  checkOutDate: string;
  numberOfPeople: number;
  numberOfChildren: number;
  numberOfAdultWomen?: number;
  numberOfAdultMen?: number;
  repeatUserFlag?: CAWiseUserFlag;
  paymentFlag?: CAWisePayment;
  /**
   * 予約した商品の税込の合計金額
   */
  amount: number;
  facilityCode: string;
  facilityName: string;
  areaCode: string;
  areaName: string;
  roomNumber?: string;
  meal?: CAWiseMeal;
  currencyType: 'JPY' | string;
  /**
   * 通貨単位に設定した通貨からJPYへの換算レー ト。通貨単位 が JPY の場合は 1 を設定します
   */
  exchangeRate: number;
}

export interface FireCaWiseTourTag {
  (
    _window: Window,
    _document: Document,
    travelId: string,
    /**
     * hash化されたデータ
     */
    hash: string,
    /**
     * 予約情報サマリ
     */
    reservationSummary: string,
    /**
     * 予約情報詳細
     */
    reservationDetail: string
  ): Promise<void>;
}
export interface FireCaWiseHotelTag {
  (
    _window: Window,
    _document: Document,
    travelId: string,
    /**
     * hash化されたデータ
     */
    hash: string,
    /**
     * 予約情報
     */
    reservation: string
  ): Promise<void>;
}
